import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";
import * as RailCstic from "./TKLTRailsCstics";

export const TKLTRailsDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  [RailCstic.Coating]: "NONE",
  [RailCstic.Accuracy]: "G4",
  [RailCstic.MountingHoleType]: "O",
  [RailCstic.ClosingPlugs]: "K3",
  [RailCstic.LocatingFace]: "O",
};
